<template>
  <div>
    <el-button type="text" @click="dialogVisible = true">批量设置价格</el-button>
    <el-dialog title="批量设置价格" :visible.sync="dialogVisible" append-to-body width="50%">
      <div class="loglabelbox">
        <el-input type="textarea" v-model="content"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="parseData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dealData: { // 数据列表
      type: Function,
    },
  },
  data() {
    return {
      dialogVisible: false,
      content: '',
    };
  },
  created() {
  },
  methods: {
    parseData() {
      console.log(this.content);
      const arr = this.content.split('\n');
      const result = [];
      arr.forEach((item) => {
        const temp = item.split('\t');
        result.push(temp);
      });
      this.$emit('dealData', result)
      this.dialogVisible = false;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
